import { Badge, Card, HStack, Text, VStack } from '@chakra-ui/react';
import { TrendsAnalyticsService } from '../../common/reservation-analytic-service';

const MetricCard = ({
  title,
  value,
  trend,
  subtitle,
}: {
  title: string;
  value: string | number;
  trend: number;
  subtitle?: string;
}) => {
  const trendText = TrendsAnalyticsService.formatTrendValue(trend);
  const trendColorScheme = TrendsAnalyticsService.getTrendColorScheme(trend);

  return (
    <Card.Root bg="white">
      <Card.Body p={6}>
        <HStack justify="space-between" mb={2}>
          <Text fontSize="sm" fontWeight="medium" color="gray.600">
            {title}
          </Text>
        </HStack>

        <HStack justify="space-between" align="flex-end">
          <VStack align="flex-start" gap={1}>
            <HStack>
              <Text fontSize="2xl" fontWeight="bold" color="gray.900">
                {value}
              </Text>

              <Badge
                color={trendColorScheme}
                fontSize="sm"
                bgColor={'white'}
                fontWeight="semibold"
                px={2}
                py={1}
                borderRadius="md"
              >
                {trendText}
              </Badge>
            </HStack>
            {subtitle && (
              <Text fontSize="xs" color="gray.500">
                {subtitle}
              </Text>
            )}
          </VStack>
        </HStack>
      </Card.Body>
    </Card.Root>
  );
};

export default MetricCard;
